<template>
  <div>
    <h1>Hilfe</h1>
    <p>Machen Sie einen kurzen Rundgang durchs Förderportal. <a nohref class="intro-link" @click="startIntroAgain">Hier starten</a></p>
    <p><a href="#latest-release">Sehen Sie sich die letzten Erneuerungen an</a></p>
    <h1>Wegleitung Gesuchstellung</h1>
    <p>Sie finden für jede Fördermassnahme eine Wegleitung, wie Sie beim Einreichen vorgehen müssen in der Navigation im Fördergeldrechner oder direkt im Fenster "Neues Gesuch erstellen". Sobald Sie die Massnahme und Gemeinde ausgewählt haben, erscheint der Link auf die entsprechende Wegleitung als PDF.</p>
    <p>Weiter finden Sie alle Informationen zu den technischen Anforderungen, Beilagen und Messungen, die Sie je nach Gesuchsart einsenden müssen. Sobald Sie das Gesuch eingereicht haben, finden Sie in der Gesuchsliste Angaben zum Status in Echtzeit. So sehen Sie jederzeit, wie weit die Gesuchsstellung fortgeschritten ist. Im Gesuchsdetail steht unter Status, was Sie als nächstes tun müssen. Weiter wird angezeigt, wenn die Zahlung erfolgt ist.</p>
    <h1>Kontakt</h1>
    <h6><strong>Energieagentur St.Gallen</strong></h6>
    <p>
      Kornhausstrasse 25<br/>
      9000 St.Gallen
    </p>
    <h6><strong>Telefon</strong></h6>
    <p>058 228 71 71</p>
    <h6><strong>Öffnungszeiten</strong></h6>
    <p>
      Montag - Donnerstag<br />
      08.00-12.00 Uhr/13.30-17.00 Uhr
    </p>
    <p>
      Freitag<br>
      08.00-12.00 Uhr/13.30-16.30 Uhr
    </p>
    <h1 id="latest-release" class="mt-5">19.10.2022 - Release Neuigkeiten</h1>
    <p>Mit dieser neuen Version des e-Förderportals kommen Sie in den Genuss folgender Neuerungen:</p>
    <p>Digitale Signatur des Gesuchs: Mit der Registrierung über E-Mail und Mobile-Nummer (Zwei-Faktor-Authentifizierung) entfällt die Unterschrift auf dem Papier.</p>
    <p>Mit dem Upload der Dokumente (Beilagen zum Gesuch) entfällt der Postversand.</p>
    <p>Beim Projektabschluss geben Sie die Kontoangaben online ein und reichen die Beilagen per Upload (drag & drop) ein.</p>
    <p>Die bewährte Suchfunktion für Ihre Gesuche wurde vereinfacht und ist nun übersichtlicher dargestellt.</p>
    <p>Wenn Sie die E-Mail-Adresse der Bauherrschaft beim Gesuch erfassen, werden die Verfügungen der Bauherrschaft per E-Mail zugestellt, es entfällt der Postversand.</p>
    <p>Wenn Sie eine Vollmacht von Ihrer Bauherrschaft haben, dann können Sie das Gesuch selbst signieren, ohne eine weitere Signatur von der Bauherrschaft einzuholen. Entsprechende Vorlagen dazu finden Sie im e-Förderportal.</p>
  </div>
</template>
<script>
  export default {
    methods: {
      startIntroAgain () {
        this.$store.dispatch('intro/ACTIVATE_INTRO_SET_FALSE').then(res => {
          const { errors } = res
          if (errors) {
            console.error(errors)
          }
          this.$router.push({
            name: 'uebersicht'
          }).catch((e) => {})
        }).catch(err => {
          console.error(err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  h6{
    margin-bottom: .5rem;
  }

  .intro-link{
    text-decoration: underline;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
      cursor: pointer;
    }
  }
</style>
